// extracted by mini-css-extract-plugin
module.exports = {"DataStoreOverviewQueriesPerSecond":"DataStoreOverviewQueriesPerSecond_YH8fk"};